// The commerce connector: everything the page's buy UI needs from a store,
// behind one small interface, so the same UI runs on this standalone preview
// site (preview-connector.js: the Storefront API) and inside the Shopify
// theme (theme-connector.js: Shopify's storefront actions and the theme's
// cart drawer). The entry file picks the connector explicitly (js/site.js,
// js/theme.js); nothing detects its environment at runtime.
//
// interface Connector {
//   getProduct(): Promise<Product>
//     The product's price and availability. Rejects on any failure.
//   addToCart(quantity): Promise<Cart>
//     Adds the product's single variant. Resolves with the updated cart and
//     notifies onCartChange listeners. Rejects on any failure.
//   buyNow(quantity): void
//     Leaves the page for checkout with only this product.
//   onCartChange(callback): () => void
//     callback(cart) whenever the cart is known to have changed, including
//     when an existing cart is restored by getProduct(). Returns unsubscribe.
// }
//
// Product: { title, available, price: { amount: number, currencyCode }, priceLabel? }
//   priceLabel: the price as the store itself formats it (the theme's Liquid
//   `money` filter); shown as is when present, else formatPrice(price)
// Cart:    { count, checkoutUrl }   (count = total quantity of all lines;
//   checkoutUrl null where the store's own cart UI leads to checkout)

/** "$65", "$65.50": whole amounts drop the cents, like the store's own labels. */
export function formatPrice({ amount, currencyCode }) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
  }).format(amount);
}

/** A minimal listener set: add() returns its own unsubscribe. */
export function createListeners() {
  const set = new Set();
  return {
    add(fn) {
      set.add(fn);
      return () => set.delete(fn);
    },
    emit(value) {
      for (const fn of set) fn(value);
    },
  };
}
